<template>
  <validation-observer v-slot="{ invalid }">
    <form @submit.prevent="submitFormData" enctype="multipart/form-data">
      <div id="content" class="app-content">
        <!-- BEGIN container -->
        <b-container>
          <!-- BEGIN row -->
          <b-row>
            <!-- BEGIN col-10 -->
            <b-col xl="12">
              <!-- BEGIN row -->
              <b-row>
                <!-- BEGIN col-9 -->
                <b-col xl="12">
                  <b-breadcrumb>
                    <b-breadcrumb-item :to="{ name: 'categories' }">
                      CATEGORIES
                    </b-breadcrumb-item>
                    <b-breadcrumb-item active>
                      {{ breadcrumbTitle }}
                    </b-breadcrumb-item>
                  </b-breadcrumb>

                  <b-row>
                    <b-col>
                      <b-card>
                        <validation-provider name="Name" v-slot="context" rules="required">
                          <b-form-group label="Name">
                            <b-input
                              v-model="name"
                              placeholder="e.g Hiking"
                              :state="getValidationState(context)"
                              v-bind="context.ariaInput"
                            />

                            <b-form-invalid-feedback v-bind="context.ariaMsg">
                              {{ context.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <b-form-group v-if="isEditPage" label="URL">
                          <b-form-input
                            :value="getCategoryUrl()"
                            readonly
                          />
                        </b-form-group>

                        <validation-provider name="Top Content" v-slot="context">
                          <b-form-group label="Top Content">
                            <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
                              {{ context.errors[0] }}
                            </small>
                            <wysiwyg-editor v-model="top_content" />
                          </b-form-group>
                        </validation-provider>

                        <validation-provider name="Dynamic SEO content" v-slot="context">
                          <b-form-group label="Dynamic SEO content">
                            <small v-if="context.errors.length" v-bind="context.ariaMsg" class="text-danger form-text">
                              {{ context.errors[0] }}
                            </small>
                            <wysiwyg-editor v-model="bottom_content" />
                          </b-form-group>
                        </validation-provider>
                      </b-card>

                      <hr />
                      <b-card title="SEO">
                      <b-form-group label="Title">
                          <b-form-input v-model="seo.title" placeholder="title" />
                      </b-form-group>

                        <b-form-group label="Meta Title">
                          <b-form-input v-model="seo.meta_title" placeholder="e.g you need a big bowl" />
                        </b-form-group>

                        <b-form-group label="Meta Description">
                          <b-form-textarea v-model="seo.meta_description" placeholder="e.g ..." />
                        </b-form-group>

                        <b-form-group label="No Index">
                          <b-form-checkbox v-model="seo.no_index">
                            Enable No-Index
                          </b-form-checkbox>
                        </b-form-group>
                      </b-card>
                    </b-col>

                    <b-col cols="4">
                      <b-card>
                        <validation-provider name="Type" v-slot="context">
                          <b-form-group label="Type">
                            <b-form-select
                              v-model="type"
                              :options="typeList"
                              :state="getValidationState(context)"
                              v-bind="context.ariaInput"
                            />

                            <b-form-invalid-feedback v-bind="context.ariaMsg">
                              {{ context.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <hr />
                        <label>Parent Category</label>
                        <multi-select
                          v-model="parent"
                          placeholder="Pick a category"
                          track-by="name"
                          label="name"
                          :options="categoryOptions"
                          :searchable="true"
                          @open="findCategory"
                          @search-change="findCategory"
                        />
                      </b-card>

                      <template v-if="isEditPage">
                        <hr />
                        <b-card title="Category images">
                          <section>
                            <h6>Desktop image</h6>

                            <div v-if="hasImage('image_desktop')" class="category-image-preview mb-3">
                              <img
                                :src="imageUrl('image_desktop')"
                                :srcset="imageSrcset('image_desktop')"
                                sizes="(max-width: 575px) 100vw, 350px"
                                alt="Desktop category image preview"
                              >
                            </div>

                            <b-form-file
                              v-model="image_desktop"
                              ref="image_desktop"
                              class="d-none"
                              accept="image/*"
                              @input="uploadImage($event, 'image_desktop')"
                            />

                            <div class="mb-2">
                              <small class="text-red">
                                <strong>Minimum width: 1372px. Recommended width: 2744px.</strong>
                              </small>
                              <small class="d-block text-muted">
                                The image will be cropped to the 1372 × 335 aspect ratio.
                              </small>
                            </div>

                            <div>
                              <b-button
                                variant="default"
                                :disabled="Boolean(uploadingImage)"
                                @click="pickImage('image_desktop')"
                              >
                                {{ uploadingImage === 'image_desktop' ? 'Uploading…' : 'Upload Desktop Image' }}
                              </b-button>

                              <b-button
                                v-if="hasImage('image_desktop')"
                                variant="danger"
                                class="ml-2"
                                :disabled="Boolean(uploadingImage)"
                                @click="deleteImg('image_desktop')"
                              >
                                Delete Image
                              </b-button>
                            </div>
                          </section>

                          <hr />

                          <section>
                            <h6>Mobile image</h6>

                            <div v-if="hasImage('image_mobile')" class="category-image-preview mb-3">
                              <img
                                :src="imageUrl('image_mobile')"
                                :srcset="imageSrcset('image_mobile')"
                                sizes="(max-width: 575px) 100vw, 350px"
                                alt="Mobile category image preview"
                              >
                            </div>

                            <b-form-file
                              v-model="image_mobile"
                              ref="image_mobile"
                              class="d-none"
                              accept="image/*"
                              @input="uploadImage($event, 'image_mobile')"
                            />

                            <div class="mb-2">
                              <small class="text-red">
                                <strong>Minimum width: 770px.</strong>
                              </small>
                              <small class="d-block text-muted">
                                The image will be cropped to the 385 × 204 aspect ratio.
                              </small>
                            </div>

                            <div>
                              <b-button
                                variant="default"
                                :disabled="Boolean(uploadingImage)"
                                @click="pickImage('image_mobile')"
                              >
                                {{ uploadingImage === 'image_mobile' ? 'Uploading…' : 'Upload Mobile Image' }}
                              </b-button>

                              <b-button
                                v-if="hasImage('image_mobile')"
                                variant="danger"
                                class="ml-2"
                                :disabled="Boolean(uploadingImage)"
                                @click="deleteImg('image_mobile')"
                              >
                                Delete Image
                              </b-button>
                            </div>
                          </section>
                        </b-card>
                      </template>

                      <hr />
                      <b-button variant="primary" type="submit" :disabled="invalid" block>
                        {{ buttonText }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'

import MultiSelect from 'vue-multiselect'
import { categories as categoriesApi } from '@/api'
import { getValidationState } from '../page-helpers'
import WysiwygEditor from '@/components/WysiwygEditor';

export default {
  name: 'CategoriesFormPage',
  components: { WysiwygEditor, MultiSelect },
  data() {
    return {
      category: {},
      name: '',
      top_content: '',
      bottom_content: '',
      type: null,
      categoryOptions: [],
      parent: null,
      image_desktop: null,
      image_mobile: null,
      uploadingImage: null,
      seo: { meta_title: '', meta_description: '', no_index: false },
    }
  },
  computed: {
    isEditPage() {
      return this.$route.name === 'categories.edit'
    },
    breadcrumbTitle() {
      return this.isEditPage ? 'EDIT' : 'NEW'
    },
    buttonText() {
      return this.isEditPage ? 'Update Category' : 'Create Category'
    },
    typeList() {
      return [
        { value: null, text: 'Please select an option' },
        { value: 'category', text: 'Category' },
        { value: 'gifttips', text: 'Gift Tips' },
      ]
    },
  },
  beforeRouteEnter(from, to, next) {
    next(vm => vm.loadContent())
  },
  methods: {
    getValidationState,
    async loadContent() {
      if (!this.isEditPage) return

      const category = await categoriesApi.findBySlug(this.$route.params.slug)
      this.category = category.data
      this.name = this.category.name
      this.top_content = this.category.top_content
      this.bottom_content = this.category.bottom_content
      this.type = this.category.type
      if (this.category && this.category.seo) {
        this.seo = this.category.seo
      }
      this.parent = this.category.parent
    },
    async submitFormData() {
      const content = {
        name: this.name,
        top_content: this.top_content,
        bottom_content: this.bottom_content,
        parent_id: this.parent ? this.parent.id : null,
        type: this.type,
        seo: this.seo,
      }
      await this.$store.dispatch('auth/refreshToken');

      if (this.isEditPage) {
        await this.handleUpdate(content)

        return
      }

      await this.handleCreate(content)
    },
    async handleCreate(data) {
      const category = await categoriesApi.create(data)
      this.$bvToast.toast(`A new category with the name "${this.name}" was created successfully.`, {
        title: 'Category created.',
        variant: 'primary',
      })

      this.$router.push({ name: 'categories.edit', params: { slug: category.data.slug } })
    },
    async handleUpdate(data) {
      await this.$store.dispatch('auth/refreshToken');
      await categoriesApi.update(this.category.id, data)

      this.$bvToast.toast(`"${this.name}" was updated successfully.`, {
        title: 'Category updated.',
        variant: 'primary',
      })
    },
    async findCategory(name = '') {
      const response = await categoriesApi.all({ filter: { name } })

      this.categoryOptions = await response.data()
    },
    pickImage(imageType) {
      this.$refs[imageType].$el.querySelector('input').click()
    },
    async uploadImage(image, imageType) {
      if (!image) return

      this.uploadingImage = imageType

      try {
        const { data } = await categoriesApi.update(this.category.id, { [imageType]: image })
        this.$set(this.category, imageType, data[imageType])

        this.$bvToast.toast('New image was successfully added to category.', {
          title: 'Image Uploaded.',
          variant: 'primary',
        })
      } catch (error) {
        this.$bvToast.toast(error.message, { title: 'Something went wrong.', variant: 'danger' })
      } finally {
        this[imageType] = null
        this.uploadingImage = null
      }
    },
    async deleteImg(imageType) {
      this.uploadingImage = imageType

      try {
        const { data } = await categoriesApi.update(this.category.id, { [imageType]: null })
        this.$set(this.category, imageType, data[imageType] || null)

        this.$bvToast.toast('Image was successfully deleted.', {
          title: 'Image Deleted.',
          variant: 'primary',
        })
      } catch (error) {
        this.$bvToast.toast(error.message, { title: 'Something went wrong.', variant: 'danger' })
      } finally {
        this[imageType] = null
        this.uploadingImage = null
      }
    },
    hasImage(imageType) {
      const image = this.category[imageType]

      return Boolean(image && (image.url || image.srcset))
    },
    imageUrl(imageType) {
      const image = this.category[imageType]

      if (!image) return ''
      if (image.url) return image.url

      return image.srcset ? image.srcset.split(',')[0].trim().split(' ')[0] : ''
    },
    imageSrcset(imageType) {
      return this.category[imageType]?.srcset || null
    },

    getCategoryUrl() {
      const slug = this.category.parent?.slug ? `${this.category.parent.slug}/${this.category.slug}` : this.category.slug
      const clientUrl = this.$store.getters['market/enabled']
        ? this.$store.getters['market/clientUrl']
        : process.env.VUE_APP_APP_URL

      return `${clientUrl}/${slug}`
    },
  },
}
</script>

<style scoped>
.category-image-preview {
  overflow: hidden;
  background: #f2f3f4;
  border-radius: 0.25rem;
}

.category-image-preview img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
